import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables.ts'
import {EntryHomepage} from './EntryHomepage.ts'

export class EntryWeb extends EntryHomepage {
    constructor() {
        super()
        void this.initialize()
    }

    async initialize() {
        await super.initialize()
    }
}

if(!UIUtilsEjsVariables.isUserOnDiscord) new EntryWeb()
